import { Capacitor, registerPlugin } from '@capacitor/core';
const AppAttestNative = registerPlugin('AppAttest', {
    web: () => import('./web').then((m) => new m.AppAttestWeb()),
});
const getPlatform = () => {
    const platform = Capacitor.getPlatform();
    if (platform === 'ios' || platform === 'android') {
        return platform;
    }
    return 'web';
};
const getFormat = (platform) => {
    if (platform === 'ios') {
        return 'apple-app-attest';
    }
    if (platform === 'android') {
        return 'google-play-integrity-standard';
    }
    return 'web-fallback';
};
const withPlatform = () => {
    const platform = getPlatform();
    return {
        platform,
        format: getFormat(platform),
    };
};
const isSupported = async () => {
    const status = await AppAttestNative.isSupported();
    return Object.assign(Object.assign({}, withPlatform()), { isSupported: status.isSupported });
};
const getCapabilities = async () => {
    return AppAttestNative.getCapabilities();
};
const prepare = async (options) => {
    const result = await AppAttestNative.prepare(options);
    return Object.assign(Object.assign({}, withPlatform()), { keyId: result.keyId });
};
const createAttestation = async (options) => {
    var _a, _b;
    const result = await AppAttestNative.createAttestation(options);
    const keyId = (_a = result.keyId) !== null && _a !== void 0 ? _a : options.keyId;
    const challenge = (_b = result.challenge) !== null && _b !== void 0 ? _b : options.challenge;
    return Object.assign(Object.assign({}, withPlatform()), { token: result.attestation, keyId,
        challenge });
};
const createAssertion = async (options) => {
    var _a;
    const result = await AppAttestNative.createAssertion(options);
    const keyId = (_a = result.keyId) !== null && _a !== void 0 ? _a : options.keyId;
    return Object.assign(Object.assign({}, withPlatform()), { token: result.assertion, keyId, payload: options.payload });
};
const generateKey = async (options) => {
    return prepare(options);
};
const attestKey = async (options) => {
    const result = await createAttestation(options);
    return Object.assign(Object.assign({}, result), { attestation: result.token });
};
const generateAssertion = async (options) => {
    const result = await createAssertion(options);
    return Object.assign(Object.assign({}, result), { assertion: result.token });
};
const AppAttest = {
    isSupported,
    getCapabilities,
    prepare,
    createAttestation,
    createAssertion,
    getWidevineFingerprint: (options) => AppAttestNative.getWidevineFingerprint(options),
    getDeviceCheckToken: () => AppAttestNative.getDeviceCheckToken(),
    storeKeyId: (options) => AppAttestNative.storeKeyId(options),
    getStoredKeyId: () => AppAttestNative.getStoredKeyId(),
    clearStoredKeyId: () => AppAttestNative.clearStoredKeyId(),
    generateKey,
    attestKey,
    generateAssertion,
};
export * from './definitions';
export { AppAttest };
//# sourceMappingURL=index.js.map